import { ComponentRef, Inject, Injectable, Renderer2, RendererFactory2, ViewContainerRef } from '@angular/core';
import { DOCUMENT } from '@angular/common';

export abstract class PoprViewService<C> {
  abstract insert<C>(componentRef: ComponentRef<C>): void;
}

/**
 * Uses Angular features to insert views into a host container
 */
@Injectable()
export class PoprNgViewService<C> implements PoprViewService<C>{
  constructor(
    private viewContainerRef: ViewContainerRef
  ) {}

  insert<C>(componentRef: ComponentRef<C>): void {
    if(componentRef) this.viewContainerRef?.insert(componentRef.hostView);
  }
}

/**
 * Inserts host views using DOM manipulation
 */
@Injectable()
export class PoprDomViewService<C> implements PoprViewService<C>{
  private readonly renderer: Renderer2;

  constructor(
    @Inject(DOCUMENT) document: Document,
    private rendererFactory: RendererFactory2
  ) {
    this.renderer = rendererFactory.createRenderer(null, null);
  }

  insert<C>(componentRef: ComponentRef<C>): void {
    if (componentRef) {
      const root = document.body.querySelector('#root0') || document.body.querySelector('div') || document.body;
      this.renderer?.insertBefore(root, componentRef.location?.nativeElement, root.firstChild);
      componentRef.changeDetectorRef?.detectChanges();
    }
  }
}
